import { UI } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { useHomeActions } from '../../../../store/home/capture/actions';
import {
  selectedActivationsByProfileYearState,
  yearsState,
} from '../../../../store/home/capture/atom';

import { CustomersActivationByProfileContent } from './components/CustomersActivationByProfileContent';

export namespace CustomersActivationByProfileTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const CustomersActivationByProfile: React.FC<CustomersActivationByProfileTypes.Props> = ({
  isMobile,
}) => {
  const { setSelectedActivationsByProfileYear } = useHomeActions();
  const { data: yearSelected } = useRecoilQuery(selectedActivationsByProfileYearState);
  const { data: years } = useRecoilQuery(yearsState);

  return (
    <UI.PeriodSelectorPanel
      flex={1}
      fullWidth
      title="HABILITAÇÕES POR PERFIL"
      onPeriodChange={setSelectedActivationsByProfileYear}
      options={years?.map((year) => ({ label: year, value: year })) || []}
      testId="customers-activation-by-profile-panel"
      selectedOption={yearSelected || ''}
      titleCustomProps={{ fontSize: Typography['fontsize.lg'] }}
      isMobile={isMobile}>
      <CustomersActivationByProfileContent isMobile={isMobile} />
    </UI.PeriodSelectorPanel>
  );
};
